import {
  canAccessAccountableBanking,
  isAccountableBankingRefused,
} from 'components/pages/Banks/Wallet/helpers';
import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';
import type { Connector } from 'types/transactions.types';
import { isWeb } from 'utils/constants';
import useGetConnectors from './useGetConnectors';

const useCanAccessAccountableBanking = () => {
  const { data } = useGetConnectors();

  const connectors = data as Connector[];

  const hasRefusedAccountableBanking = connectors?.some(
    isAccountableBankingRefused,
  );

  const { data: user } = useGetCurrentCustomerData();

  return (
    isWeb && !hasRefusedAccountableBanking && canAccessAccountableBanking(user)
  );
};

export default useCanAccessAccountableBanking;
